import React, { useEffect } from 'react'
import { MetricTimeUnit, Sentiment } from 'enums'
import { createMetric } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { CountTypeStrings } from 'enums/CountType'
import { getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

const createSearch = (
  detailSetting: InsightContentSettingType,
  countType: CountTypeStrings,
  timeUnits?: MetricTimeUnitStrings[],
  forceNotScale?: boolean
) => {
  const { filter, precision, topicId } = detailSetting

  const transformedFilter = {
    ...filter,
    additionalSentiments: [[Sentiment.POSITIVE, Sentiment.NEGATIVE]]
  }

  const sparklineTimeUnits = timeUnits || [
    MetricTimeUnit.ALL,
    getSparklineMetricTimeUnit(filter?.publishedDate)
  ]
  const option = {
    forceNotScale: forceNotScale ?? false
  }
  const measure = getMeasureTypeByCountType(countType)

  return createMetric(
    -1,
    '',
    precision!,
    [topicId!],
    transformedFilter,
    getMetricSeries(measure),
    sparklineTimeUnits,
    option
  )
}

const RunSearchEffect = ({
  detailSetting,
  countType,
  children,
  timeUnits,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  children: React.ReactNode
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting, countType, timeUnits, forceNotScale)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.MEASURE_WITH_SENTIMENT,
        searches: [searches],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, countType, timeUnits, forceNotScale, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
